exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "[data-theme=light][data-v-003fa335] .article-css{background:#fff!important}[data-theme=dark][data-v-003fa335] .article-css{background:#1e1e20!important}[data-theme=light][data-v-003fa335] .article-css{color:rgba(0,0,0,.9)!important}[data-theme=dark][data-v-003fa335] .article-css{color:hsla(0,0%,100%,.9)!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-003fa335","scoped":true,"hasInlineConfig":false}!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/policies/deleteAccountPrivacy.vue
// module id = 309
// module chunks = 0